import React from 'react';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <FrontHeader />
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: June 08, 2026</p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you create an account, post a job, submit a quotation, or communicate with other users. This may include your name, email address, phone number, company details, vessel information, and payment information.</p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to operate, maintain, and improve our platform, to connect ship owners with service providers, to process payments securely, to communicate with you about your account and transactions, and to comply with legal obligations.</p>
        </section>

        <section>
          <h2>3. Sharing of Information</h2>
          <p>We do not sell or rent your personal information to third parties. We may share your information with other users as necessary to facilitate transactions (e.g., vessel details to service providers). We may also share information with payment processors, escrow services, and legal authorities when required by law.</p>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>We implement industry-standard security measures including encryption, secure servers, and regular security audits to protect your data. However, no method of transmission over the internet is 100% secure.</p>
        </section>

        <section>
          <h2>5. Your Rights</h2>
          <p>You may access, correct, or delete your personal information by logging into your account or contacting support. You may also opt out of marketing communications at any time.</p>
        </section>

        <section>
          <h2>6. Cookies</h2>
          <p>We use cookies to enhance your experience, remember preferences, and analyze platform usage. You can disable cookies in your browser settings, but some features may not function properly.</p>
        </section>

        <section>
          <h2>7. Changes to This Policy</h2>
          <p>We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "last updated" date.</p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>If you have questions about this privacy policy, please contact us at privacy@seazex.com.</p>
        </section>
      </div>
      <FrontFooter />
    </div>
  );
};

export default PrivacyPolicy;